/**
 * CancelConfirmationModal - Tipo 1: Modal de Confirmación
 *
 * Usa el componente global ConfirmationModal con soporte para checkbox.
 */

import React from 'react';
import { Cancel as CancelIcon } from '@mui/icons-material';
import { ConfirmationModal } from '../../ui/Modal';

export interface CancelConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  recordCode?: string;
  loading?: boolean;
}

const CancelConfirmationModal: React.FC<CancelConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  recordCode,
  loading = false,
}) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={
        recordCode ? `¿Desea cancelar el registro ${recordCode}?` : '¿Desea cancelar este registro?'
      }
      confirmText={loading ? 'Cancelando...' : 'Sí'}
      cancelText="No"
      variant="default"
      icon={<CancelIcon />}
      loading={loading}
      requireCheckbox={true}
      checkboxLabel="Confirmo que deseo cancelar este registro"
    />
  );
};

export default CancelConfirmationModal;
